var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPosorders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30.5,
    r: 30,
    fill: "#2F80ED",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.367 19.148L35.367 17.573C32.733 16.1915 31.416 15.5 30 15.5C28.584 15.5 27.267 16.19 24.633 17.573L24.1515 17.8265L37.536 25.475L43.56 22.46C42.591 21.362 41.028 20.5415 38.367 19.145M44.622 24.446L38.625 27.446V32C38.625 32.2984 38.5065 32.5845 38.2955 32.7955C38.0845 33.0065 37.7984 33.125 37.5 33.125C37.2016 33.125 36.9155 33.0065 36.7045 32.7955C36.4935 32.5845 36.375 32.2984 36.375 32V28.571L31.125 31.196V45.356C32.202 45.0875 33.4275 44.4455 35.367 43.427L38.367 41.852C41.5935 40.1585 43.2075 39.3125 44.1045 37.79C45 36.269 45 34.3745 45 30.59V30.4145C45 27.575 45 25.799 44.622 24.446ZM28.875 45.356V31.196L15.378 24.446C15 25.799 15 27.575 15 30.4115V30.587C15 34.3745 15 36.269 15.8955 37.79C16.7925 39.3125 18.4065 40.16 21.633 41.8535L24.633 43.427C26.5725 44.4455 27.798 45.0875 28.875 45.356ZM16.44 22.4615L30 29.2415L35.1165 26.684L21.7875 19.067L21.633 19.148C18.9735 20.543 17.409 21.3635 16.44 22.463",
    fill: "#2F80ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosorders);
export default __webpack_public_path__ + "static/media/posorders.0c9aa884fe6188c321c9d7d0c869c32a.svg";
export { ForwardRef as ReactComponent };